import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { USWDSBreadcrumbComponent } from './breadcrumb.component';



@NgModule({
  declarations: [USWDSBreadcrumbComponent],
  imports: [
    CommonModule
  ],
  exports: [USWDSBreadcrumbComponent]
})
export class USWDSBreadcrumbModule { }
